import React from 'react';
import './ui.css';

export type ButtonVariant = 'primary' | 'secondary' | 'outline' | 'danger' | 'ghost';
export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  loading?: boolean;
  icon?: React.ReactNode;
  iconRight?: React.ReactNode;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'secondary', size = 'md', loading = false, icon, iconRight, children, className = '', disabled, ...rest }, ref) => {
    const cls = [
      'ui-btn',
      `ui-btn--${variant}`,
      `ui-btn--${size}`,
      loading ? 'ui-btn--loading' : '',
      className,
    ].filter(Boolean).join(' ');

    return (
      <button ref={ref} className={cls} disabled={disabled || loading} {...rest}>
        {loading ? <span className="ui-btn__spinner" aria-hidden /> : icon}
        {children}
        {!loading && iconRight}
      </button>
    );
  }
);

Button.displayName = 'Button';
export default Button;
